import React from 'react'

import moment from 'moment'
import PropTypes from 'prop-types'

import css from './DeliverySlot.css'

const WarningAddressChanged = ({ tempDate, changeType }) => {
  if (changeType === 'unavailable') {
    return (
      <span>
        <span className={css.warningTriangle} />
        We couldn&apos;t find any available delivery days for your new address. Please choose a
        different address.
      </span>
    )
  }

  const date = moment(tempDate, 'YYYY-MM-DD').format('Do MMMM')

  return (
    <span>
      <span className={css.warningTriangle} />
      {changeType === 'slot' ? (
        <>
          Your delivery slot isn&apos;t available at your new address, so we&apos;ve updated it to
          the next available slot on {date}.
        </>
      ) : (
        <>
          Your delivery day isn&apos;t available at your new address, so we&apos;ve updated it to{' '}
          {date}.
        </>
      )}
    </span>
  )
}

WarningAddressChanged.propTypes = {
  tempDate: PropTypes.string,
  changeType: PropTypes.oneOf(['day', 'slot', 'unavailable']),
}

WarningAddressChanged.defaultProps = {
  tempDate: undefined,
  changeType: 'day',
}

export { WarningAddressChanged }
